import React from 'react';
import { Anchor, Box, Heading, Page, Paragraph } from '@zillow/constellation-10';
import Hpx404House from '../Logo/Hpx404House';

type Props = {
  errorCode: 404 | 500;
  ctaText: string;
  ctaUrl: string;
};

export default function HotpadsErrorPage({ errorCode, ctaText, ctaUrl }: Props) {
  return (
    <Page.Root
      css={{
        backgroundColor: 'transparent',
        margin: 0,
      }}
    >
      <Page.Content>
        <Box
          css={{
            display: 'flex',
            flexDirection: { base: 'column', lg: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box css={{ display: 'flex', flexDirection: 'column', marginBottom: { base: 'loose', lg: 0 } }}>
            <Heading level={2} textStyle="heading-md">
              {errorCode === 404 ? 'Yikes, this page was not found.' : 'Uh oh, something broke.'}
            </Heading>
            <Paragraph>
              Go back to browsing pads that are hot. <Anchor href={ctaUrl}>{ctaText}</Anchor>
            </Paragraph>
          </Box>
          <Hpx404House />
        </Box>
      </Page.Content>
    </Page.Root>
  );
}
